const RAW_URL_REGEX = /\bhttps?:\/\/[^\s]+/g;
const TRAILING_PUNCTUATION_REGEX = /[)\].,;:!?]+$/;

/**
 * Automatically converts URLs in the editor text into clickable links.
 *
 * This function:
 * - Detects URLs in the text using regex
 * - Removes link formatting from broken/invalid URLs (e.g., when user deletes characters)
 * - Applies link formatting to valid URLs that aren't already linked
 * - Preserves existing properly formatted links to avoid unnecessary updates
 *
 * @param {Editor} editor - The Quill editor instance
 * @returns {void}
 */
const applyLinkFormatting = (editor) => {
  const text = editor.getText();
  const matches = [...text.matchAll(RAW_URL_REGEX)];
  const length = editor.getLength();

  // Clear all existing auto-link formatting first (silent avoids feedback loops)
  if (length > 1) {
    editor.formatText(0, length - 1, 'link', false, 'silent');
  }

  if (matches.length === 0) {
    return;
  }

  matches.forEach((match) => {
    if (match.index == null) return;

    const rawUrl = match[0];
    const url = rawUrl.replace(TRAILING_PUNCTUATION_REGEX, '');
    if (!url) return;

    editor.formatText(match.index, url.length, 'link', url, 'silent');
  });
};

export { applyLinkFormatting };
